import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Store from '@/store/store'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/user/:user_id/',
      name: 'home',
      component: Home
    },
    {
      path: '/user_setting/:user_id/',
      name: 'setting',
      component: () => import('./views/UserSetting.vue')
    },
    {
      path: '/paid_days_off/:user_id/',
      name: 'paid_days_off',
      component: () => import('./views/PaidDaysOff.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('./views/Admin.vue')
    },
    {
      path: '/',
      name: 'login',
      component: () => import('./views/Login.vue'),
      meta: { isPublic: true }
    },
    {
      path: '/tablet',
      name: 'tablet',
      component: () => import('./views/Tablet.vue'),
      meta: { isPublic: true }
    },
    {
      path: '/users/',
      name: 'users',
      component: () => import('./views/Users.vue')
    },
    {
      path: '/clients/',
      name: 'clients',
      component: () => import('./views/Clients.vue')
    },
    {
      path: '/calendar/',
      name: 'calendar',
      component: () => import('./views/Calendar.vue')
    },
    {
      path: '/manage_attendance/',
      name: 'manage_attendance',
      component: () => import('./views/ManageAttendance.vue')
    },
    {
      path: '/manage_timesheets/',
      name: 'manage_timesheets',
      component: () => import('./views/ManageTimesheets.vue')
    },
    {
      path: '/manage_attendance_result/',
      name: 'attendance_result',
      component: () => import('./views/ManageAttendanceResult.vue')
    },
    {
      path: '/manage_costs/',
      name: 'manage_costs',
      component: () => import('./views/ManageCosts.vue')
    },
    {
      path: '/manage_paid_days_off/',
      name: 'manage_paid_days_off',
      component: () => import('./views/ManagePaidDaysOff.vue')
    },
    // {
    //   path: '/development/',
    //   name: 'development',
    //   component: () => import('./views/Development.vue')
    // },
    {
      path: '/manage_expenses/',
      name: 'manage_expenses',
      component: () => import('./views/ManageExpenses.vue')
    },
  ]
})
router.beforeEach((to, from, next) => {
  let requiresAuth = to.matched.some(record => !record.meta.isPublic)
  const isLoggedIn = Store.getters["auth/isLoggedIn"]
  if (requiresAuth && !isLoggedIn) {
    Store.commit('auth/saveToUrl', to.fullPath)
    next({ name: "login" });
  } else if (to.matched.length < 1) {
    Store.commit('auth/clearToUrl')
    next({ name: "login" });
  }
  else {
    next();
  }

})

export default router